import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles({
  container: {
    height: "100vh",
    width: "100vw",
  },
  grid: {
    paddingTop: 16
  },
  form: {
    marginTop: "10vh",
    width: "100%"
  },
  card: {
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    maxWidth: 400,
    marginTop: 20,
    padding: 15,
    background: "whitesmoke"
  },
  textfield: {
    marginTop: 20
  },
  btn: {
    marginTop: 20,
    backgroundColor: '#f25139'
  },
  media: {
      width: 50
  }


});
export default useStyles;
